import React, { memo } from 'react';

const TrashInner = () => (
    <svg viewBox="0 0 14 16">
        <path d="M3.2522 15.5C2.42495 15.5 1.7522 14.8273 1.7522 14V5H0.252197V3.5H2.5022H3.2522V2C3.2522 1.17275 3.92495 0.5 4.7522 0.5H9.2522C10.0794 0.5 10.7522 1.17275 10.7522 2V3.5H11.5022H13.7522V5H12.2522V14C12.2522 14.8273 11.5794 15.5 10.7522 15.5H3.2522ZM9.2522 2H4.7522V3.5H9.2522V2ZM10.0022 5H4.0022H3.2522V14H10.7529L10.7522 5H10.0022ZM6.2522 6.5H4.7522V12.5H6.2522V6.5ZM9.2522 6.5H7.7522V12.5H9.2522V6.5Z" />
    </svg>
);

export const Trash = memo(TrashInner);
